module.exports = __webpack_public_path__ + "static/media/04-paolobonetti-hovercolor.8cc12e80.jpg";